
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'LoadingModal',
})
export default class LoadingModal extends Vue {
  @Prop({}) public phrase: string;
}
